import type { LanguageContextType } from "~/context/LanguageContext";

import ar from "./ar";
import de from "./de";
import en from "./en";
import fr from "./fr";

/** Shape every locale must implement. English is the source of truth. */
export type Dict = typeof en;

// Typing the record as `Dict` makes a missing or misspelled key in any locale
// a compile error rather than an `undefined` rendered into the page.
const dict: Record<LanguageContextType["lang"], Dict> = { en, fr, de, ar };

export default dict;
